import React from 'react';
import FavouriteBtn from '../../atoms/FavouriteBtn/FavouriteBtn';
import LazyPicture from '../../atoms/LazyPicture';
import RouterLink from '../../atoms/RouterLink';
import Reminder from '../../atoms/Reminder/Reminder';
import CuratorPicks from '../../atoms/CuratorPicks/CuratorPicks';
import { convertDate } from '../Events';
import ScrollAnimation from 'react-animate-on-scroll';
import { pathJoin, getMediaHost, injectImageResolution, get, getListingItemURL } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { BlurCard, EBlurCardImageTypes, isShowRuleIsHide } from '../../atoms/BlurCard/BlurCard';
var FeaturedEventBlock = function FeaturedEventBlock(_ref) {
  var event = _ref.event,
    curatorsCopy = _ref.curatorsCopy,
    lang = _ref.lang,
    analytics = _ref.analytics,
    hostLink = _ref.hostLink,
    multipleDates = _ref.multipleDates,
    countryItems = _ref.countryItems,
    themeValues = _ref.themeValues,
    _ref$listingBlock = _ref.listingBlock,
    listingBlock = _ref$listingBlock === void 0 ? false : _ref$listingBlock;
  var firstEvents = event;
  var eventsAnalytics = analytics.eventsAnalytics,
    params = analytics.params;
  var firstImage = get(firstEvents, 'image');
  var curators = get(firstEvents, 'curators.curators');
  var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), firstImage])), 700, 428);
  var imgSrcMob = injectImageResolution("".concat(pathJoin([getMediaHost(), firstImage])), 325, 300);
  var firstImageAlt = get(firstEvents, 'title');
  var eventIsBusiness = get(event, 'eventIsBusiness');

  // const videoSrc = 'https://www.visitdubai.com/-/media/dctcm/campaigns/2019/h/hollywood-campaign/video/v4/1600_450.mp4';

  return /*#__PURE__*/React.createElement(React.Fragment, null, isShowRuleIsHide(event) ? /*#__PURE__*/React.createElement("div", {
    className: "events__item"
  }, /*#__PURE__*/React.createElement(BlurCard, {
    hint: event,
    lang: lang,
    cardType: EBlurCardImageTypes.event,
    hitAnalytics: eventsAnalytics,
    hitParams: params,
    reminderTheme: themeValues,
    countryItems: countryItems,
    showWithAnimation: true
  })) : /*#__PURE__*/React.createElement("div", {
    className: "events__featured-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, !listingBlock ? /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 col-xl-6 events__featured-image-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__featured-image-wrap"
  }, firstImage && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: getListingItemURL(hostLink, firstEvents.urlSlug, firstEvents.url),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), event.englishTitle);
    },
    title: firstImageAlt
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "events__featured-image",
    src: imgSrcMob,
    alt: firstImageAlt
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 ".concat(listingBlock ? 'col-xl-6' : 'col-xl-3', " events__featured-info-col")
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__featured-fav-wrapper"
  }, /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: firstEvents && firstEvents.objectID,
    classes: 'events__fav-btn',
    analyticsClick: function analyticsClick(eventTitle) {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['addToFavAnalytics'], params), "".concat(eventTitle, ": ").concat(event.englishTitle));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "row flex-md-grow-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 col-lg-12 d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement(CuratorPicks, {
    curators: curators,
    copy: curatorsCopy,
    analytics: {
      eventsAnalytics: eventsAnalytics,
      params: params,
      name: event.englishTitle
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "events__text-sight"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.3
  }, firstEvents && firstEvents.category && firstEvents.category.join(' '))), /*#__PURE__*/React.createElement("a", {
    className: "events__item-title",
    "aria-label": "Event",
    href: getListingItemURL(hostLink, firstEvents.urlSlug, firstEvents.url),
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), event.englishTitle);
    }
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.45
  }, firstEvents.title)), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.6
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-small events__text"
  }, firstEvents.introText, " ")), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.7
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__date-item"
  }, firstEvents.eventNextAvailableDate ? "".concat(multipleDates, " ").concat(convertDate(firstEvents.eventNextAvailableDate, '', lang)) : firstEvents.datesRange && convertDate(firstEvents.datesRange.from_formatted, firstEvents.datesRange.from_formatted === firstEvents.datesRange.to_formatted ? '' : firstEvents.datesRange.to_formatted, lang))), /*#__PURE__*/React.createElement("div", {
    className: "events__push-bottom"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.8
  }, !eventIsBusiness && /*#__PURE__*/React.createElement(Reminder, {
    lang: lang,
    event: event,
    countryItems: countryItems,
    themeValues: themeValues,
    modeFeatured: true,
    eventsAnalytics: eventsAnalytics,
    params: params
  }))))))))));
};
export default FeaturedEventBlock;